export const useGetFilteredProjects = (
  projects: Project[],
  searchTerm: string
): Project[] => {
  return projects?.filter((project) => {
    if (!searchTerm) return true;
    return project?.name?.toLowerCase().includes(searchTerm?.toLowerCase());
  });
};
